import React from 'react';
import { useHistory } from 'react-router-dom';
import { Container, Card, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { userAccountTypeToRouteType } from '@rd-web-markets/shared/dist/util/redirectUser';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootswatch/dist/litera/bootstrap.min.css';

// Default styles for Material Icons
const defaultIconStyles = {
  fontSize: '64px',
  display: 'block',
  margin: '0 auto 20px',
};

export default function NotFound({ currentSessionFetchFinished }) {
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);

  const correctUserAccountTypePart = userAccountTypeToRouteType[user?.account_type]
  let redirectUrl = '/'
  if (correctUserAccountTypePart) {
    // e.g. /manager, /client, etc
    redirectUrl = `/${correctUserAccountTypePart}`
  }
  
  if (!currentSessionFetchFinished) {
    return <Loader />
  }

  return (
    <Container fluid className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <Card className="text-center p-4 shadow-lg" style={{ maxWidth: '400px', borderRadius: '12px' }}>
        {/* Material Icon */}
        <span className="material-icons text-info rounded-circle" style={defaultIconStyles}>
          error_outline
        </span>
        
        <Card.Body>
          <Card.Title className="display-4 mb-3">404</Card.Title>
          <Card.Text className="mb-4 text-muted">
            Oops! The page you’re looking for can’t be found.
          </Card.Text>
          <Button variant="info" size="lg" onClick={() => history.push(redirectUrl)}>          
            Go Back Home
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
}
